import { Header } from '../../../utility/types/components/types';

(function () {
    var header: Header = {
        prevScrollpos: window.pageYOffset,
        $elem: $('header.header'),
        shadowHeight: 10,
        hiddenPos: 200,
        scrollTimer: null,
        init: function () {
            header.controls();
        },
        controls: function () {
            var $body = $('body');
            $body.on('click', "[data-db-target-for='header-journals']", function (e) {
                if ($(this).hasClass('js--open')) {
                    $body.removeAttr('data-effect');
                    $('.dropdown.menu-parent').removeClass('open-on-click');
                } else {
                    $body.attr('data-effect', 'body-overlay');
                    $('.dropdown.menu-parent').addClass('open-on-click');
                }
                document.querySelectorAll('.load-on-click').forEach((image: HTMLImageElement) => 
                    image.src = image.dataset.source
                );
            });

            window.onscroll = function () {
                var currentScrollPos: number = null;
                if (header.scrollTimer) {
                    clearTimeout(header.scrollTimer); // clear any previous pending timer
                }
                currentScrollPos = window.pageYOffset;
                header.scrollTimer = setTimeout(() => header.handleScroll(currentScrollPos), 10); // set new timer
            };
        },
        handleScroll: function (currentScrollPos) {
            if (header.prevScrollpos > currentScrollPos || currentScrollPos <= header.hiddenPos) {
                header.$elem.css({top: '0'});
                $('.embo-menu').removeClass('force-hidden');
                $('main').removeClass('header-is-hidden');
            } else {
                let topValue = -(header.$elem.height() + header.shadowHeight);
                $('.embo-menu').addClass('force-hidden');
                $('main').addClass('header-is-hidden');
                header.$elem.css({top: topValue + 'px'});
            }
            header.prevScrollpos = currentScrollPos;
        },
    };
    UX.header = header;
})();
